import { Accomodation } from "common";
import axios from "axios";

const appConfig = require("../app_config.json");

export default new class AccomodationService {
    async getAccomodations(token: string): Promise<Accomodation[]> {
        const response = await axios.post(
            `${appConfig.baseUrl}${appConfig.stage}/get-accomodations`, 
            {}, 
            { headers: { "Authorization": token } }
        );

        return Promise.resolve(response.data);
    }
}